export default function FinalCTA() {
  return (
    <section id="contact" className="py-36 bg-[#0A0F1E]">
      <div className="max-w-[1280px] mx-auto px-8">
        <div className="text-center space-y-12">
          <div className="flex items-center justify-center gap-4 mb-8">
            <span className="block w-10 h-[1px] bg-[#C9A96E]"></span>
            <p className="text-[11px] font-semibold tracking-[0.24em] uppercase text-[#C9A96E]">
              Final CTA
            </p>
            <span className="block w-10 h-[1px] bg-[#C9A96E]"></span>
          </div>

          <h2 className="text-[48px] lg:text-[56px] font-light text-white leading-[1.2] tracking-[-0.025em]">
            Let's <span className="font-semibold">connect</span>
          </h2>

          <p className="text-[17px] text-white/60 leading-[1.8] font-light max-w-[680px] mx-auto">
            Whether you are an investor, operator, strategic partner, or simply interested in our companies, we'd love to hear from you.
          </p>

          <div className="flex items-center justify-center gap-8 pt-8">
            <a
              href="/contact"
              className="px-9 py-4 bg-[#C9A96E] text-[#0A0F1E] text-[13px] font-semibold tracking-[0.04em] rounded-sm hover:bg-[#B8955A] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Contact Diivy
            </a>
            <a
              href="/portfolio"
              className="px-9 py-4 bg-transparent border border-white/20 text-white text-[13px] font-semibold tracking-[0.04em] rounded-sm hover:border-[#C9A96E] hover:bg-[#C9A96E] hover:text-[#0A0F1E] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Portfolio
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}